import { getLDSBusInfo } from "../../../utils/gatewayFunctions";
import { getAuxiliaryHubsFromLdsus } from "../ldsuTransformers";
import {
    getIOControllerActuatorsFromConfig,
    isSensorFromEntityDevice,
} from "./deviceUtils";

// Helper function to check if actuator should be included.
// At the network list level we trust the per‑channel CLS/type classification
// from getLDSBusInfo/getActuatorList, so we no longer re‑filter by device OBJ
// (which previously hid valid relay channels on auxiliary hubs).
const isActuatorIncluded = (actuator: any): boolean => {
    return true;
};

// Helper function to filter out sensors from zone/room/group/hub entity devices
const filterActualSensors = (busSensors: any[], devices: any[]): any[] =>
    busSensors.filter((s: any) => !isSensorFromEntityDevice(s, devices));

// Helper function to count sensors, controllers, and auxiliary hubs from bus devices (same logic as gateways)
export const countBusDevices = (
    devices: any[],
    configList: any[],
    statusDevices: any[]
): { sensors: number; controllers: number; auxiliaryHubs: number } => {
    let totalSensors = 0;
    let totalControllers = 0;
    let totalAuxiliaryHubs = 0;

    const actuatorKeysSeen = new Set<string>();
    for (let busNumber = 1; busNumber <= 3; busNumber++) {
        const { sensors: busSensors, actuators } = getLDSBusInfo(
            busNumber.toString(),
            devices,
            configList,
            statusDevices
        );

        const actualSensors = filterActualSensors(busSensors, devices);
        const filteredActuators = actuators.filter(isActuatorIncluded);

        const ioControllerActuators = getIOControllerActuatorsFromConfig(
            busNumber.toString(),
            devices,
            configList,
            statusDevices
        );

        filteredActuators.forEach((a: any) =>
            actuatorKeysSeen.add(`${String(a?.UID)}:${Number(a?.said)}`)
        );
        ioControllerActuators.forEach((a: any) =>
            actuatorKeysSeen.add(`${String(a?.UID)}:${Number(a?.said)}`)
        );
        totalSensors += actualSensors.length;
        totalControllers = actuatorKeysSeen.size;

        const auxiliaryHubs = getAuxiliaryHubsFromLdsus(
            busNumber.toString(),
            devices,
            configList,
            statusDevices
        );

        totalAuxiliaryHubs += auxiliaryHubs.length;
    }

    return {
        sensors: totalSensors,
        controllers: totalControllers,
        auxiliaryHubs: totalAuxiliaryHubs,
    };
};
